"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import type { Assessment } from "@/features/assessment/types";
import type { AppLocale } from "@/core/i18n/config";
import { AssessmentFeaturedCard } from "./assessment-featured-card";
interface AssessmentHeroSectionProps {
  featured: Assessment[];
  locale: AppLocale;
}
export function AssessmentHeroSection(t0) {
  const $ = _c(21);
  const {
    featured,
    locale
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true
    };
    t4 = {
      duration: 0.6
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = locale === "hi" ? "\u092B\u0940\u091A\u0930\u094D\u0921 \u0905\u0938\u0947\u0938\u092E\u0947\u0902\u091F" : "Featured Assessment";
  let t6;
  if ($[4] !== t5) {
    t6 = <p className="mb-2 text-[11px] font-bold tracking-[0.2em] text-primary uppercase">{t5}</p>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = locale === "hi" ? "\u0905\u092A\u0928\u0940 \u092E\u093E\u0928\u0938\u093F\u0915 \u0938\u094D\u0925\u093F\u0924\u093F \u0938\u092E\u091D\u0928\u0947 \u0938\u0947 \u0936\u0941\u0930\u0941\u0906\u0924 \u0915\u0930\u0947\u0902" : "Start by understanding where you are";
  let t8;
  if ($[6] !== t7) {
    t8 = <h2 className="font-heading text-2xl font-light tracking-tight text-foreground sm:text-3xl lg:text-4xl">{t7}</h2>;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t6 || $[9] !== t8) {
    t9 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="mb-10 text-center sm:text-left">{t6}{t8}</motion.div>;
    $[8] = t6;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== featured || $[12] !== locale) {
    let t11;
    if ($[14] !== locale) {
      t11 = (assessment, i) => <AssessmentFeaturedCard key={assessment.id} assessment={assessment} locale={locale} index={i} />;
      $[14] = locale;
      $[15] = t11;
    } else {
      t11 = $[15];
    }
    t10 = featured.map(t11);
    $[11] = featured;
    $[12] = locale;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <div className="grid grid-cols-1 gap-6 md:grid-cols-3">{t10}</div>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t9) {
    t12 = <section className="bg-background px-4 py-16 sm:px-6 lg:px-8"><div className="mx-auto max-w-7xl">{t9}{t11}</div></section>;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}